// Vendor imports
const classNames = require('classnames')
const _ = require('lodash')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const ArticleCard = require('client-v2/common/components/cards/article')
const tag = require('client-v2/common/utils/hyperscript')

// BEM Block entity definition
const bem = BemEntity('ArticleProfileRelated')

const callbackKeys = [
  'onAddClick',
  'onCardClick',
  'onCountClick',
  'onDomainClick',
  'onMoreClick',
  'onPreviewClick',
  'onSeen',
  'onShareClick'
]

function ArticleProfileRelated(props) {
  if (!props.items || !props.items.length) {
    return null
  }
  return (
    tag('section', {
      className: classNames(
        props.className,
        bem.block()
      )
    },
      tag(ArticleProfileRelatedHeading, props),
      tag(ArticleProfileRelatedGrid, props)
    )
  )
}

if (__DEV__) {
  // Prop checking imports
  const PropTypes = require('prop-types')
  const Portal = require('client-v2/common/components/portal')
  const { FeedItemRecord } = require('client-v2/common/containers/feed/records')

  ArticleProfileRelated.propTypes = {
    // Values
    articleMixButtonPortalContainer: Portal.containerPropType,
    className: PropTypes.string,
    items: PropTypes.arrayOf(
      PropTypes.shape(FeedItemRecord.propTypes)
    )
  }
  // Callback propTypes
  callbackKeys.forEach(key => {
    ArticleProfileRelated.propTypes[key] = PropTypes.func.isRequired
  })
}

module.exports = ArticleProfileRelated

// Block element components

function ArticleProfileRelatedHeading() {
  return (
    tag('div', {
      className: bem.element('heading')
    },
      'Related Posts'
    )
  )
}

function ArticleProfileRelatedGrid(props) {
  const { items } = props
  const callbacks = _.pick(props, callbackKeys)
  return (
    tag('div', {
      className: bem.element('grid')
    },
      items.map(item => (
        tag(ArticleCard, {
          key: `related-item:${item.id}`,
          className: bem.element('grid-item'),
          article: item.article,
          pageContext: item.pageContext,
          portalContainer: props.articleMixButtonPortalContainer,
          ...callbacks
        })
      ))
    )
  )
}
